<template>
	<div class="category-filter-wrapper">
		<ul class="category-filter-list">
			<li
				v-for="filter in filters"
				:key="filter"
				class="category-filter-list-item"
			>
				<category-filter
					:label="filter"
					:icon="filter"
					:filterValue="filter"
					:clearSelectedFilters="clearSelectedFilters"
					@change="handleFilterChange"
					v-model="checkedFilter"
				/>
			</li>
		</ul>
	</div>
</template>

<script>
import CategoryFilter from "./CategoryFilter.vue";
import { mapActions } from "vuex";

export default {
	name: "CategoryFilterList",
	components: {
		CategoryFilter
	},
	props: {
		filters: {
			type: Array,
			default: () => [
				"Asian",
				"Alcohol",
				"BBQ",
				"Breakfast",
				"Burgers",
				"Chinese",
				"Indian",
				"Italian",
				"Mediterranean",
				"Mexican",
				"Pizza",
				"Vegan",
				"Vegetarian"
			]
		},
		clearSelectedFilters: { type: Boolean }
	},
	data() {
		return {
			checkedFilter: ""
		};
	},
	methods: {
		...mapActions({
			filterByTag: "restList/filterByTag"
		}),
		handleFilterChange(tag) {
			document.getElementById("rest-search-input").value = "";
			this.filterByTag(tag);
			this.$emit("filterSelected");
		}
	}
};
</script>

<style lang="scss" scoped>
.category-filter-wrapper {
	overflow: auto;
	position: relative;

	@media (max-width: $max-content-width + (2 * $container-padding)) {
		padding-left: $container-padding;
	}
}

.category-filter-list {
	max-width: $max-content-width;
	margin-left: auto;
	margin-right: auto;
	display: flex;
	margin-bottom: $section-spacing;

	@media (min-width: $max-content-width + (2 * $container-padding) + 1) {
		margin-left: auto;
		margin-right: auto;
	}
}

.category-filter-list-item {
	flex: 1 1 auto;

	&:not(:last-of-type) {
		padding-right: 10px;
	}
}
</style>